import { Accordion, Button, Form } from "react-bootstrap";
import { Input, PageWrapper } from "../../components";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { getSystemSettingList, updateSystemSetting } from "../../api/system-setting";
import { FormProvider, useForm } from "react-hook-form";
import { camelToUpperSnake, toUpperSnakeCase } from "../../shared/utils";

const SystemSetting = ({ }) => {
    const form = useForm()
    const [systemSettings, setSystemSettings] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const response = await getSystemSettingList()
        setSystemSettings(response)
        form.reset(response)
    }

    return <PageWrapper headerProps={{ title: "SYSTEM_SETTING" }}>
        {systemSettings && <>
            {systemSettings.map((systemSetting, index) => (
                <SystemSettingForm systemSetting={systemSetting} />
            ))}
        </>}
    </PageWrapper>
}

const SystemSettingForm = ({ systemSetting }) => {
    const { t } = useTranslation();
    const form = useForm();
    const contentType = typeof systemSetting.value;

    useEffect(() => {
        if (Array.isArray(systemSetting.value)) {
            const values = systemSetting.value.reduce((acc, item, index) => {
                acc[index] = item;
                return acc;
            }, {});
            form.reset(values);
        } else {
            form.reset(systemSetting.value);
        }
    }, [systemSetting]);

    const update = async (data) => {
        let valueToUpdate;
        if (Array.isArray(systemSetting.value)) {
            valueToUpdate = Object.values(data);
        } else {
            valueToUpdate = data;
        }
        await updateSystemSetting(systemSetting.id, valueToUpdate);
    }

    const generateContent = (parent, content) => {
        if (contentType !== 'object' || content === null) {
            return null;
        }

        // Handle arrays
        if (Array.isArray(content)) {
            return (
                <div className="mt-3">
                    {content.map((item, index) => (
                        <div key={index} className="mb-3">
                            {Object.entries(item).map(([key, value]) => (
                                <Input
                                    key={key}
                                    name={`${index}.${key}`}
                                    label={`${t(camelToUpperSnake(key))} ${index + 1}`}
                                    defaultValue={value}
                                    rules={{ required: t("CANT_BE_EMPTY") }}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            );
        }

        // Handle objects
        if (contentType === 'object') {
            return Object.entries(content).map(([key, value]) => {
                if (typeof value === 'object' && value !== null) {
                    return (
                        <Accordion defaultActiveKey={'0'} className="mt-4 mb-4">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>{t(camelToUpperSnake(key))}</Accordion.Header>
                                <Accordion.Body>
                                    {generateContent(isEmpty(parent) ? key : parent + "." + key, value)}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    );
                }
                return (
                    <Input
                        key={key}
                        name={parent + "." + key}
                        label={t(camelToUpperSnake(key))}
                        defaultValue={value}
                        rules={{ required: t("CANT_BE_EMPTY") }}
                    />
                );
            });
        }

        return null;
    };

    return <>
        <FormProvider {...form}>
            <Form onSubmit={form.handleSubmit(update)}>
                <Accordion defaultActiveKey={'0'} className="mb-4">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>{t(toUpperSnakeCase(systemSetting.name))}</Accordion.Header>
                        <Accordion.Body>
                            {generateContent(['string', 'number'].includes(contentType) ? systemSetting.name : "", systemSetting.value)}
                            <Button type="submit">{t("SAVE")}</Button>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Form>
        </FormProvider>
    </>
}

export default SystemSetting;